import { useMutation } from '@tanstack/react-query';

import { postEmerchantPayment } from '../api/payment.api';

interface PostEmerchantPaymentParams {
    orderId: string | undefined;
    loyaltyId: number;
    paymentRequest: Record<string, unknown>;
}

export const usePostEmerchantPayment = () => {
    return useMutation({
        mutationFn: ({ orderId, loyaltyId, paymentRequest }: PostEmerchantPaymentParams) =>
            postEmerchantPayment(orderId, loyaltyId, paymentRequest),
    });
};
